"use client";

import { useEffect } from "react";
import { rememberJobCategory } from "@/lib/experiments/post-apply-single-ask";

/**
 * Renders nothing. Remembers this job's category in sessionStorage so the
 * layout-level `ConfirmApplyToast` (which only knows the hop's job id) can
 * name it in the post-apply-single-ask card. Client-only, so the cached job
 * HTML is unchanged.
 */
export function JobCategoryMemo({
	jobId,
	categorySlug,
	categoryName,
}: {
	jobId: string;
	categorySlug: string | null;
	categoryName: string | null;
}) {
	useEffect(() => {
		rememberJobCategory(jobId, categorySlug, categoryName);
	}, [jobId, categorySlug, categoryName]);
	return null;
}
